import FilterTab, { type FilterTabProps } from '@/shared/ui/filter-tab';

const baseGroupOptions = [
  { id: 'sid', title: 'Sites' },
  { id: 'aid', title: 'Ad units' },
  { id: 'day', title: 'Date' },
] as const;

// The per-page report is an optional cabinet section: the tab exists only for
// accounts the admin switched it on for (users_pp.cabinet_settings).
const pagesOption = { id: 'pages', title: 'Pages' } as const;

export type GroupOptions = 'sid' | 'aid' | 'day' | 'pages';

interface GroupSwitchProps extends Pick<FilterTabProps, 'disabled'> {
  value: GroupOptions;
  onChange: (value: GroupOptions) => void;
  /** Show the Pages tab (the account has the `page_stats` cabinet section). */
  withPages?: boolean;
}

export default function GroupSwitch({
  disabled,
  value = 'sid',
  onChange,
  withPages = false,
}: GroupSwitchProps) {
  const groupOptions: ReadonlyArray<{ id: GroupOptions; title: string }> =
    withPages ? [...baseGroupOptions, pagesOption] : baseGroupOptions;

  return (
    <FilterTab
      items={groupOptions}
      active={groupOptions.find(({ id }) => value === id)}
      onChange={(id: GroupOptions) => {
        onChange(id);
      }}
      disabled={disabled}
    />
  );
}
